const BASE = process.env.REACT_APP_BACKEND_URL || 'http://localhost:5000';

export const fetchGames = async (params = {}) => {
  const query = new URLSearchParams(params).toString();
  const res = await fetch(`${BASE}/games${query ? `?${query}` : ''}`);
  return res.json();
};

export const fetchUnityCatalog = async () => {
  try { const res = await fetch(`${BASE}/unity-catalog`); return res.json(); } catch { return { games: [] }; }
};

export const fetchGame = async (id) => {
  const res = await fetch(`${BASE}/games/${id}`);
  return res.json();
};

// Parties EN COURS (statut live rapporté par l'hôte du jeu → /match/status). Jamais throw.
export const fetchLiveMatches = async () => {
  try {
    const res = await fetch(`${BASE}/match/status`);
    if (!res.ok) return [];
    const d = await res.json();
    return Array.isArray(d.matches) ? d.matches : [];
  } catch { return []; }
};

export const fetchGenres = async () => {
  const res = await fetch(`${BASE}/genres`);
  return res.json();
};

// Playlists "partage de parties" : une entrée par jeu ayant reçu des enregistrements.
export const fetchPlaylists = async () => {
  try {
    const res = await fetch(`${BASE}/playlists`);
    if (!res.ok) return [];
    return res.json();
  } catch {
    return [];
  }
};

// Les chaînes YouTube de l'écosystème (VertinGo / Saga / Horizons).
export const fetchChannels = async () => {
  try {
    const res = await fetch(`${BASE}/channels`);
    if (!res.ok) return [];
    return res.json();
  } catch {
    return [];
  }
};

// Newsletter — inscription email (MVP capture d'audience).
export const subscribeNewsletter = async (email, lang, themes) => {
  try {
    const res = await fetch(`${BASE}/newsletter/subscribe`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ email, lang, source: 'app-store', themes: themes || [] }),
    });
    return res.json();
  } catch {
    return { ok: false, error: 'network' };
  }
};

// Dernières vidéos d'une chaîne (fil d'actus).
export const fetchChannelVideos = async (key, limit = 12) => {
  try {
    const res = await fetch(`${BASE}/channels/${key}/videos?limit=${limit}`);
    if (!res.ok) return [];
    return res.json();
  } catch {
    return [];
  }
};

// Abonnement Premium (Stripe) — crée une session Checkout côté serveur, renvoie l'URL de paiement.
export const createCheckout = async (userId) => {
  const res = await fetch(`${BASE}/billing/checkout`, {
    method: 'POST', headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ user_id: userId }),
  });
  if (!res.ok) throw new Error('checkout');
  return res.json();               // { url }
};
// Confirme le paiement au retour (accorde le Premium si payé). { session_id } → { ok, premium }
export const confirmBilling = async (sessionId) => {
  try {
    const res = await fetch(`${BASE}/billing/confirm`, {
      method: 'POST', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ session_id: sessionId }),
    });
    return res.ok ? res.json() : { ok: false };
  } catch { return { ok: false }; }
};

// Beacon de clic monétisation (1st-party, agrégé & anonyme → aucune donnée perso, hors RGPD sensible).
// Alimente les métriques du dashboard (clics affiliation/pub par label). Best-effort, non bloquant.
export const trackClick = (kind, label) => {
  try {
    const body = JSON.stringify({ kind, label });
    if (navigator.sendBeacon) {
      navigator.sendBeacon(`${BASE}/track/click`, new Blob([body], { type: 'application/json' }));
    } else {
      fetch(`${BASE}/track/click`, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body, keepalive: true });
    }
  } catch { /* jamais bloquer la navigation */ }
};

// Rapporte une GROSSE PERF joueur dans le fil d'actu (kind perf, dédoublonné backend par id).
// Appelé automatiquement par nakamaAuth.leaderboardSubmit quand le score est notable.
export const reportPerf = async ({ game, player, score, text }) => {
  try {
    const id = `perf:${game}:${player}:${score}`;
    await fetch(`${BASE}/news`, {
      method: 'POST', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        id, kind: 'perf', icon: '🏆', tag: 'Perf',
        title: `${player} explose ${game} !`,
        text: text || `Score ${score}`,
        // expire après 3 jours → le fil reste frais
        expires: new Date(Date.now() + 3 * 86400000).toISOString(),
      }),
    });
  } catch { /* best-effort */ }
};

// Fil d'actualités curé (events spéciaux, vidéos/articles, nouveaux jeux, perfs) publié par l'agent.
export const fetchNews = async (kind) => {
  try {
    const res = await fetch(`${BASE}/news${kind ? `?kind=${encodeURIComponent(kind)}` : ''}`);
    if (!res.ok) return [];
    const d = await res.json();
    return Array.isArray(d.items) ? d.items : [];
  } catch {
    return [];
  }
};
